import { gql } from "lib/apolloClient";
import { journalPostFragment } from "AppComponents/Post/modules/PostFragments";

export const getOrganizationPostFeedQuery = gql`
  query GetOrganizationPostFeed(
    $filters: PostFilterInput
    $organizationId: ID!
    $after: String
    $translationFilter: TranslatedLabelFilter
    $uids: [String!]
    $isDP: Boolean!
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      ... on Organization {
        id
        name
        posts(last: 5, filters: $filters, after: $after) {
          totalCount
          courseWisePostCount {
            course {
              id
              title
            }
            teacherInApproval
            studentInApproval
            inApproval
            published
            draft
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            node {
              ...postItem
            }
          }
        }
      }
    }
  }
  ${journalPostFragment.journalPostFeed}
`;

export const getReviewPermissionByCurriculumProgramQuery = gql`
  query getReviewPermissionByCurriculumProgram(
    $configurationEntityGroupFilters: [ConfigurationEntityGroupFilter!]
    $isAdminPage: Boolean!
    $isSettingsPage: Boolean!
  ) {
    platform {
      configuration(
        filters: {
          configurationEntityGroupFilters: $configurationEntityGroupFilters
          isSettingsPage: $isSettingsPage
        }
      ) {
        ...configurationResponseItem
        __typename
      }
      __typename
    }
  }

  fragment configurationResponseItem on ConfigurationResponse {
    configurations @include(if: $isSettingsPage) {
      ...configurationV2SettingItem
      __typename
    }
    configurations @skip(if: $isSettingsPage) {
      ...configurationV2Item
      __typename
    }
    entityGroups @include(if: $isAdminPage) {
      entityId
      entityType
      __typename
    }
    __typename
  }

  fragment configurationV2SettingItem on ConfigurationV2 {
    id
    uidV2
    configuration
    aclControlParameterType
    valueType
    value
    configurationGroup
    parentConfigurations {
      id
      __typename
    }
    __typename
  }

  fragment configurationV2Item on ConfigurationV2 {
    id
    uidV2
    configuration
    aclControlParameterType
    valueType
    value
    isLocked
    __typename
  }
`;
